<template>
  <router-view/>
</template>

<script>
  export default {
    name: 'invoices-page',
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/analytics/InvoicesPage.vue